import { Terminal } from '../../api/terminals';
import { WebsocketCommandResponse } from '../MainWebsocketCommands';
import { WebsocketCommand } from '../useManagedWebsocket';

export class WebsocketTerminalRequestCommand extends WebsocketCommand {
    public async execute(ws: WebSocket, terminal: Terminal | null): Promise<WebsocketCommandResponse> {
        ws.send(
            JSON.stringify({
                command: 'terminalChange',
                terminal: terminal,
            })
        );
        return { success: true };
    }
}
